// extracted by mini-css-extract-plugin
export default {"container":"index__container__cayzY"};